var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalentConnectLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 36,
    viewBox: "0 0 268 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 17,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.63965H16.5055V36H0V4.63965Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_195_1741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 17,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2199 30.8637C9.56677 27.9379 9.17348 24.5504 10.1135 21.3254C11.0806 18.0088 13.3231 15.337 16.276 13.809C14.2347 13.2416 12.6229 11.64 12.1509 9.5356C12.0955 9.28931 12.0232 9.04172 11.9356 8.79672C10.8872 5.87087 7.74085 4.19324 4.72087 4.94373C1.33596 5.78447 -0.639537 9.25578 0.32629 12.5698C0.733769 13.965 1.59515 15.1049 2.7054 15.8734C4.59579 17.1836 5.41461 19.5369 4.77374 21.7445C4.21539 23.6645 4.17799 25.7587 4.77374 27.8206C6.23215 32.8689 11.0961 36.0952 16.1754 35.6993C14.1109 34.6046 12.3972 32.9489 11.2199 30.8637Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_195_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.639526 4.19336V36.0953H16.276V4.19336H-0.639526Z",
    fill: "url(#paint0_linear_195_1741)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 28,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8937 4.63965H37.3024V36H10.8937V4.63965Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_195_1741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 27,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1631 9.5356C25.2185 9.28931 25.2894 9.04172 25.3771 8.79672C26.4268 5.87087 29.5731 4.19324 32.5931 4.94373C35.9767 5.78447 37.9535 9.25578 36.9877 12.5698C36.5802 13.965 35.7175 15.1049 34.6086 15.8734C32.7182 17.1836 31.8981 19.5369 32.5402 21.7445C33.0973 23.6645 33.136 25.7587 32.5402 27.8206C30.8961 33.5111 24.9245 36.8921 19.194 35.3705C13.2224 33.7857 9.75754 27.6142 11.4764 21.7213C12.6847 17.5781 16.1289 14.6923 20.116 13.9934C20.1495 13.9869 20.1831 13.9818 20.2192 13.9766C22.6382 13.6516 24.6292 11.9147 25.1631 9.5356Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_195_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75769 4.19336V36.8896H37.9537V4.19336H9.75769Z",
    fill: "url(#paint1_linear_195_1741)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 2,
    width: 11,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8646 2.98901H23.4378V12.5622H13.8646V2.98901Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_195_1741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 3,
    width: 11,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4275 7.76925C23.4275 8.0813 23.3978 8.39207 23.3359 8.69897C23.2753 9.00587 23.1851 9.30374 23.0651 9.59259C22.9452 9.88143 22.7982 10.1561 22.6241 10.4166C22.45 10.677 22.2527 10.9169 22.031 11.1387C21.8092 11.3592 21.568 11.5578 21.3076 11.7306C21.0471 11.9046 20.7724 12.0516 20.4823 12.1716C20.1934 12.2915 19.8943 12.3818 19.5874 12.4424C19.2805 12.503 18.9697 12.5339 18.6564 12.5339C18.343 12.5339 18.0335 12.503 17.7254 12.4424C17.4185 12.3818 17.1206 12.2915 16.8304 12.1716C16.5416 12.0516 16.2669 11.9046 16.0065 11.7306C15.746 11.5578 15.5049 11.3592 15.2831 11.1387C15.0613 10.9169 14.864 10.677 14.6899 10.4166C14.5158 10.1561 14.3688 9.88143 14.2489 9.59259C14.129 9.30374 14.0387 9.00587 13.9768 8.69897C13.9162 8.39207 13.8853 8.0813 13.8853 7.76925C13.8853 7.4559 13.9162 7.14642 13.9768 6.83953C14.0387 6.53263 14.129 6.23476 14.2489 5.94462C14.3688 5.65578 14.5158 5.38111 14.6899 5.12064C14.864 4.86145 15.0613 4.62032 15.2831 4.39852C15.5049 4.17802 15.746 3.98073 16.0065 3.80665C16.2669 3.63257 16.5416 3.48556 16.8304 3.36564C17.1206 3.24572 17.4185 3.15546 17.7254 3.09485C18.0335 3.03424 18.343 3.0033 18.6564 3.0033C18.9697 3.0033 19.2805 3.03424 19.5874 3.09485C19.8943 3.15546 20.1934 3.24572 20.4823 3.36564C20.7724 3.48556 21.0471 3.63257 21.3076 3.80665C21.568 3.98073 21.8092 4.17802 22.031 4.39852C22.2527 4.62032 22.45 4.86145 22.6241 5.12064C22.7982 5.38111 22.9452 5.65578 23.0651 5.94462C23.1851 6.23476 23.2753 6.53263 23.3359 6.83953C23.3978 7.14642 23.4275 7.4559 23.4275 7.76925Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_195_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8853 3.0033V12.5339H23.4275V3.0033H13.8853Z",
    fill: "url(#paint2_linear_195_1741)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 7,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91296 0H14.1947V4.96969H8.91296V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_195_1741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8852 2.38169C13.8852 2.539 13.8698 2.69374 13.8401 2.84719C13.8092 3.00064 13.764 3.14893 13.7034 3.29464C13.6441 3.43907 13.5706 3.57575 13.4829 3.70599C13.3965 3.83623 13.2972 3.95615 13.1863 4.06705C13.0754 4.17794 12.9555 4.27595 12.8253 4.36363C12.695 4.45003 12.5571 4.52353 12.4126 4.58413C12.2682 4.64345 12.1186 4.68858 11.9652 4.71953C11.8117 4.74919 11.657 4.76466 11.4997 4.76466C11.3437 4.76466 11.1876 4.74919 11.0342 4.71953C10.8807 4.68858 10.7312 4.64345 10.5867 4.58413C10.4423 4.52353 10.3043 4.45003 10.1741 4.36363C10.0439 4.27595 9.92394 4.17794 9.81304 4.06705C9.70214 3.95615 9.60285 3.83623 9.51646 3.70599C9.42877 3.57575 9.35527 3.43907 9.29595 3.29464C9.23535 3.14893 9.19022 3.00064 9.16056 2.84719C9.12961 2.69374 9.11414 2.539 9.11414 2.38169C9.11414 2.22566 9.12961 2.07092 9.16056 1.91747C9.19022 1.76402 9.23535 1.61444 9.29595 1.47002C9.35527 1.32559 9.42877 1.18891 9.51646 1.05867C9.60285 0.928432 9.70214 0.80851 9.81304 0.697614C9.92394 0.586717 10.0439 0.487427 10.1741 0.401031C10.3043 0.314636 10.4423 0.241134 10.5867 0.180528C10.7312 0.121212 10.8807 0.0760799 11.0342 0.0451321C11.1876 0.0141844 11.3437 0 11.4997 0C11.657 0 11.8117 0.0141844 11.9652 0.0451321C12.1186 0.0760799 12.2682 0.121212 12.4126 0.180528C12.5571 0.241134 12.695 0.314636 12.8253 0.401031C12.9555 0.487427 13.0754 0.586717 13.1863 0.697614C13.2972 0.80851 13.3965 0.928432 13.4829 1.05867C13.5706 1.18891 13.6441 1.32559 13.7034 1.47002C13.764 1.61444 13.8092 1.76402 13.8401 1.91747C13.8698 2.07092 13.8852 2.22566 13.8852 2.38169Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_195_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11414 0V4.76466H13.8852V0H9.11414Z",
    fill: "url(#paint3_linear_195_1741)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 0,
    width: 6,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1077 0H28.3894V4.96969H23.1077V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_195_1741)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_195_1741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 0,
    width: 6,
    height: 5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1999 2.38169C28.1999 2.539 28.1844 2.69374 28.1535 2.84719C28.1225 3.00064 28.0774 3.14893 28.0181 3.29464C27.9575 3.43907 27.884 3.57575 27.7976 3.70599C27.7099 3.83623 27.6119 3.95615 27.501 4.06705C27.3901 4.17794 27.2689 4.27595 27.1386 4.36363C27.0084 4.45003 26.8717 4.52353 26.726 4.58413C26.5816 4.64345 26.4333 4.68858 26.2786 4.71953C26.1251 4.74919 25.9704 4.76466 25.8143 4.76466C25.657 4.76466 25.5023 4.74919 25.3488 4.71953C25.1941 4.68858 25.0458 4.64345 24.9014 4.58413C24.7557 4.52353 24.619 4.45003 24.4887 4.36363C24.3585 4.27595 24.2373 4.17794 24.1264 4.06705C24.0155 3.95615 23.9175 3.83623 23.8298 3.70599C23.7434 3.57575 23.6699 3.43907 23.6093 3.29464C23.55 3.14893 23.5049 3.00064 23.4739 2.84719C23.443 2.69374 23.4275 2.539 23.4275 2.38169C23.4275 2.22566 23.443 2.07092 23.4739 1.91747C23.5049 1.76402 23.55 1.61444 23.6093 1.47002C23.6699 1.32559 23.7434 1.18891 23.8298 1.05867C23.9175 0.928432 24.0155 0.80851 24.1264 0.697614C24.2373 0.586717 24.3585 0.487427 24.4887 0.401031C24.619 0.314636 24.7557 0.241134 24.9014 0.180528C25.0458 0.121212 25.1941 0.0760799 25.3488 0.0451321C25.5023 0.0141844 25.657 0 25.8143 0C25.9704 0 26.1251 0.0141844 26.2786 0.0451321C26.4333 0.0760799 26.5816 0.121212 26.726 0.180528C26.8717 0.241134 27.0084 0.314636 27.1386 0.401031C27.2689 0.487427 27.3901 0.586717 27.501 0.697614C27.6119 0.80851 27.7099 0.928432 27.7976 1.05867C27.884 1.18891 27.9575 1.32559 28.0181 1.47002C28.0774 1.61444 28.1225 1.76402 28.1535 1.91747C28.1844 2.07092 28.1999 2.22566 28.1999 2.38169Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_195_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4275 0V4.76466H28.1999V0H23.4275Z",
    fill: "url(#paint4_linear_195_1741)"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4022 25.5953C59.6594 25.5953 59.807 25.4562 59.807 25.1905V13.8957H62.851C63.1166 13.8957 63.2557 13.7566 63.2557 13.4909V10.8685C63.2557 10.6029 63.1166 10.468 62.851 10.468H52.7071C52.4373 10.468 52.3024 10.6029 52.3024 10.8685V13.4909C52.3024 13.7566 52.4373 13.8957 52.7071 13.8957H55.7469V25.1905C55.7469 25.4562 55.8987 25.5953 56.1516 25.5953H59.4022Z",
    fill: "#52C4C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3632 10.468C74.0596 9.84401 73.579 9.84401 73.2712 10.468L66.3358 25.1146C66.2093 25.3971 66.3358 25.5953 66.6351 25.5953H70.1892C70.4043 25.5953 70.5729 25.4772 70.653 25.2706L71.1463 24.0016H76.4923L76.9856 25.2706C77.0657 25.4772 77.2301 25.5953 77.4493 25.5953H81.0035C81.2986 25.5953 81.4293 25.3971 81.2986 25.1146L74.3632 10.468ZM73.8235 17.1758L75.3118 20.9744H72.3268L73.8235 17.1758Z",
    fill: "#52C4C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0615 25.5953C94.3271 25.5953 94.4663 25.4562 94.4663 25.1905V22.5724C94.4663 22.3068 94.3271 22.1676 94.0615 22.1676H89.504V10.8685C89.504 10.6029 89.3648 10.468 89.0992 10.468H85.8781C85.6125 10.468 85.4734 10.6029 85.4734 10.8685V25.1905C85.4734 25.4562 85.6125 25.5953 85.8781 25.5953H94.0615Z",
    fill: "#52C4C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.561 25.5953C108.827 25.5953 108.966 25.4562 108.966 25.1905V22.5724C108.966 22.3068 108.827 22.1676 108.561 22.1676H102.772V20.3927H107.773C108.042 20.3927 108.177 20.2451 108.177 19.9921V17.5679C108.177 17.3023 108.042 17.1631 107.773 17.1631H102.772V13.8957H108.561C108.827 13.8957 108.966 13.7566 108.966 13.4909V10.8685C108.966 10.6029 108.827 10.468 108.561 10.468H99.1464C98.8808 10.468 98.7417 10.6029 98.7417 10.8685V25.1905C98.7417 25.4562 98.8808 25.5953 99.1464 25.5953H108.561Z",
    fill: "#52C4C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.477 25.5951C117.742 25.5951 117.882 25.456 117.882 25.1904V17.9725L126.25 25.5951C126.883 26.177 127.334 25.9198 127.334 25.2326V10.8684C127.334 10.6028 127.199 10.4679 126.933 10.4679H123.847C123.582 10.4679 123.447 10.6028 123.447 10.8684V17.8334L114.972 10.3667C114.412 9.8734 113.99 10.1222 113.99 10.8094V25.1904C113.99 25.456 114.125 25.5951 114.395 25.5951H117.477Z",
    fill: "#52C4C7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.709 25.5953C138.966 25.5953 139.114 25.4562 139.114 25.1905V13.8957H142.158C142.423 13.8957 142.562 13.7566 142.562 13.4909V10.8685C142.562 10.6029 142.423 10.468 142.158 10.468H132.014C131.744 10.468 131.609 10.6029 131.609 10.8685V13.4909C131.609 13.7566 131.744 13.8957 132.014 13.8957H135.054V25.1905C135.054 25.4562 135.205 25.5953 135.458 25.5953H138.709Z",
    fill: "#52C4C7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.412 26C157.316 26 159.652 24.9038 161.081 23.0951C161.229 22.918 161.17 22.7494 160.942 22.5892L158.282 20.8184C158.075 20.6709 157.898 20.7088 157.742 20.9154C156.992 21.8219 155.841 22.3657 154.412 22.3657C151.911 22.3657 150.254 20.7088 150.254 18.0316C150.254 15.3502 151.911 13.6975 154.412 13.6975C155.841 13.6975 156.992 14.2371 157.742 15.1436C157.898 15.3502 158.075 15.3924 158.282 15.2448L160.942 13.4698C161.17 13.3138 161.208 13.1241 161.039 12.9302C159.593 11.1341 157.27 10.0632 154.412 10.0632C149.487 10.0632 146.215 13.1663 146.215 18.0316C146.215 22.897 149.487 26 154.412 26Z",
    fill: "#AA81F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.242 26C178.175 26 181.468 22.897 181.468 18.0316C181.468 13.1663 178.175 10.0632 173.242 10.0632C168.318 10.0632 165.046 13.1663 165.046 18.0316C165.046 22.897 168.318 26 173.242 26ZM173.242 22.3657C170.742 22.3657 169.085 20.7088 169.085 18.0316C169.085 15.3502 170.742 13.6975 173.242 13.6975C175.763 13.6975 177.437 15.3502 177.437 18.0316C177.437 20.7088 175.763 22.3657 173.242 22.3657Z",
    fill: "#AA81F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.728 25.5951C189.994 25.5951 190.133 25.456 190.133 25.1904V17.9725L198.502 25.5951C199.134 26.177 199.585 25.9198 199.585 25.2326V10.8684C199.585 10.6028 199.45 10.4679 199.185 10.4679H196.098C195.833 10.4679 195.698 10.6028 195.698 10.8684V17.8334L187.224 10.3667C186.663 9.8734 186.241 10.1222 186.241 10.8094V25.1904C186.241 25.456 186.376 25.5951 186.646 25.5951H189.728Z",
    fill: "#AA81F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.46 25.5951C208.725 25.5951 208.865 25.456 208.865 25.1904V17.9725L217.233 25.5951C217.866 26.177 218.317 25.9198 218.317 25.2326V10.8684C218.317 10.6028 218.182 10.4679 217.916 10.4679H214.83C214.565 10.4679 214.43 10.6028 214.43 10.8684V17.8334L205.955 10.3667C205.395 9.8734 204.973 10.1222 204.973 10.8094V25.1904C204.973 25.456 205.108 25.5951 205.378 25.5951H208.46Z",
    fill: "#AA81F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.503 25.5953C233.769 25.5953 233.908 25.4562 233.908 25.1905V22.5724C233.908 22.3068 233.769 22.1676 233.503 22.1676H227.715V20.3927H232.715C232.985 20.3927 233.12 20.2451 233.12 19.9921V17.5679C233.12 17.3023 232.985 17.1631 232.715 17.1631H227.715V13.8957H233.503C233.769 13.8957 233.908 13.7566 233.908 13.4909V10.8685C233.908 10.6029 233.769 10.468 233.503 10.468H224.089C223.823 10.468 223.684 10.6029 223.684 10.8685V25.1905C223.684 25.4562 223.823 25.5953 224.089 25.5953H233.503Z",
    fill: "#AA81F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M246.496 26C249.401 26 251.737 24.9038 253.166 23.0951C253.313 22.918 253.254 22.7494 253.027 22.5892L250.366 20.8184C250.16 20.6709 249.983 20.7088 249.827 20.9154C249.076 21.8219 247.925 22.3657 246.496 22.3657C243.996 22.3657 242.339 20.7088 242.339 18.0316C242.339 15.3502 243.996 13.6975 246.496 13.6975C247.925 13.6975 249.076 14.2371 249.827 15.1436C249.983 15.3502 250.16 15.3924 250.366 15.2448L253.027 13.4698C253.254 13.3138 253.292 13.1241 253.124 12.9302C251.678 11.1341 249.355 10.0632 246.496 10.0632C241.572 10.0632 238.3 13.1663 238.3 18.0316C238.3 22.897 241.572 26 246.496 26Z",
    fill: "#AA81F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M263.75 25.5953C264.007 25.5953 264.154 25.4562 264.154 25.1905V13.8957H267.198C267.464 13.8957 267.603 13.7566 267.603 13.4909V10.8685C267.603 10.6029 267.464 10.468 267.198 10.468H257.055C256.785 10.468 256.65 10.6029 256.65 10.8685V13.4909C256.65 13.7566 256.785 13.8957 257.055 13.8957H260.094V25.1905C260.094 25.4562 260.246 25.5953 260.499 25.5953H263.75Z",
    fill: "#AA81F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_1741",
    x1: 8.39704,
    y1: 4.08272,
    x2: 7.94815,
    y2: 36.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117187,
    stopColor: "#23E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#23E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#24E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#25E0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273437,
    stopColor: "#25E0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#26E0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#26DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#27DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#27DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#28DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#29DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#29DDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585937,
    stopColor: "#2ADDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2ADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#2BDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#2BDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#2CDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#2CDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#2DDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#2EDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#2ED9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2FD9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#2FD9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#30D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#30D8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#31D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#32D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#32D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#33D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#33D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#34D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#34D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#35D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#36D4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#36D4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#37D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#37D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#38D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#38D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#39D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#3BD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#3BD0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#3CD0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#3CCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#3DCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#3ECEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#3ECEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#3FCEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#3FCDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#40CDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#40CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#41CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#42CCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#42CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#43CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#43CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#44CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#44CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#45C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#46C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#46C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#47C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#47C8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#48C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#48C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#49C6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#4AC6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#4AC6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#4BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#4BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#4CC4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#4CC4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#4DC4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#4EC3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#4EC3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#4FC2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#4FC2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#50C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#50C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#51C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#52C0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#52C0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#53BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#53BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#54BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#54BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#55BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#56BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#56BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#57BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#57BCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#58BCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#58BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#59BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#59BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#5ABAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#5BBAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#5BB9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#5CB9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#5CB9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#5DB8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#5DB8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#5EB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#5FB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#5FB6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#60B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#60B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#61B5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#61B5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#62B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#63B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#63B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#64B3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#64B3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#65B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#65B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#66B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#67B1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#67B1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#68B0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#68B0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#69B0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#69AFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6AAFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#6BAEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#6BAEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#6CAEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#6CADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#6DADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#6DACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#6EACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#6FACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#6FABE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#70ABE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#70AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#71AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#71A9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#72A9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#73A9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#73A8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#74A8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#74A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#75A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#75A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#76A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#77A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#77A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#78A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#78A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#79A4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#79A4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#7AA3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#7BA3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#7BA3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#7CA2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#7CA2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#7DA1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#7DA1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#7EA1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#7FA0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#7FA0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#809FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#809FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#819EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#819EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#829EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#839DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#839DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#849CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#849CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#859CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#859BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#869BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#879AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#879AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#889AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#8899ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#8999ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#8998ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#8A98ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#8A98ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#8B97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#8C97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#8C96EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#8D96EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#8D96EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#8E95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8E95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#8F94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#9094EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#9094EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#9193EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#9193EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#9292EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#9292EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#9391EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#9491EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#9491EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#9590EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#9590EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#968FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#968FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#978FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#988EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#988EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#998DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#998DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#9A8DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#9A8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#9B8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#9C8BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#9C8BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#9D8BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#9D8AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#9E8AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#9E89F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#9F89F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#A089F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#A088F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#A188F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#A187F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#A287F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#A286F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#A386F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#A486F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#A485F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#A585F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#A584F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#A684F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#A684F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#A783F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#A883F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#A882F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#A982F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#A982F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992648,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA81F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_1741",
    x1: 24.3275,
    y1: 4.00243,
    x2: 23.8654,
    y2: 37.0863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20E4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#20E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195313,
    stopColor: "#23E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#23E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#24E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#24E0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351563,
    stopColor: "#25E0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#26E0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#26DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#27DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#27DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#28DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#29DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#29DDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#2ADDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#2ADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#2BDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#2BDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#2CDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#2DDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#2DDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2EDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#2ED9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#2FD9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#30D9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#30D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#31D8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#31D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#32D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#32D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#33D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#34D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#34D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#35D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#35D4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#36D4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#37D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#37D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#38D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#38D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#39D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#3BD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#3BD0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#3CD0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#3CCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#3DCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#3ECEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#3ECEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#3FCEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#3FCDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#40CDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#41CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#41CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#42CCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#42CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#43CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#44CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#44CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#45C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#45C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#46C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#46C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#47C8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#48C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#48C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#49C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#49C6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#4AC6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#4BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#4BC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#4CC4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#4CC4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#4DC4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#4DC3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#4EC3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#4FC2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#4FC2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#50C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#50C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#51C1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#52C0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#52C0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#53BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#53BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#54BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#55BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#55BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#56BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#56BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#57BCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#57BCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#58BCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#59BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#59BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#5ABAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#5ABAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#5BBAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#5CB9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#5CB9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#5DB8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#5DB8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#5EB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#5EB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#5FB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#60B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#60B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#61B5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#61B5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#62B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#63B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#63B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#64B3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#64B3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#65B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#66B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#66B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#67B1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#67B1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#68B0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#68B0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#69AFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#6AAFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#6AAFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6BAEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#6BAEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#6CADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#6DADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#6DADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#6EACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#6EACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#6FABE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#6FABE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#70AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#71AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#71AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#72A9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#72A9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#73A8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#74A8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#74A8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#75A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#75A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#76A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#77A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#77A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#78A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#78A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#79A4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#79A4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#7AA3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#7BA3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#7BA2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#7CA2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#7CA2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#7DA1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#7EA1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#7EA0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#7FA0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#7FA0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#809FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#819FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#819EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#829EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#829DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#839DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#839DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#849CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#859CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#859BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#869BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#869BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#879AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#889AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#8899ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#8999ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#8998ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#8A98ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#8A98ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#8B97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#8C97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#8C96EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#8D96EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#8D95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#8E95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#8F95EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#8F94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#9094EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9093EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#9193EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#9293EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#9292EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#9392EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#9391EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#9491EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#9490EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#9590EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#9690EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#968FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#978FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#978EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#988EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#998EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#998DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#9A8DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#9A8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#9B8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#9B8BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#9C8BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#9D8BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#9D8AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#9E8AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#9E89F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#9F89F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#A089F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#A088F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#A188F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#A187F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#A287F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#A386F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#A386F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#A486F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#A485F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#A585F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#A584F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#A684F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#A783F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#A783F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#A883F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#A882F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#A982F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988097,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA81F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_195_1741",
    x1: 18.7244,
    y1: 2.93764,
    x2: 18.5895,
    y2: 12.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0137941,
    stopColor: "#1CE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#1CE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#1CE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#1DE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#1EE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#1EE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#1FE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#20E4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#20E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#23E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#24E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#24E0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#25E0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#26DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#27DFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#27DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#28DEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#29DDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#29DDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2ADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2BDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2BDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2CDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2DDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#2DDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#2EDADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#2FD9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#2FD9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#30D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31D8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#32D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#32D7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#33D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#34D6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#34D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#35D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#36D4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#36D4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#37D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#38D3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#38D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#39D2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3AD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3BD0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3CD0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#3CCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#3DCFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#3ECEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#3FCEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#3FCDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#40CDE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#41CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#41CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#42CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#43CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#43CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#44CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#45C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#45C9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#46C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986206,
    stopColor: "#47C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47C8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_195_1741",
    x1: 11.5337,
    y1: -0.0332941,
    x2: 11.4662,
    y2: 4.79772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0137919,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#18E9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#19E9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#1AE8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#1AE8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#1BE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1CE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#1CE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#1DE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#1EE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1EE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#1FE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#20E4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#20E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#23E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986208,
    stopColor: "#24E1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24E1DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_195_1741",
    x1: 25.8476,
    y1: -0.0332945,
    x2: 25.7801,
    y2: 4.79772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0137919,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#17EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#18E9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#19E9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#19E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#1AE8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1BE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#1BE7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#1CE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#1DE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1DE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#1EE5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#1FE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#1FE4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#20E4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#21E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#22E3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#22E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986208,
    stopColor: "#23E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E1DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentConnectLogo);
export default __webpack_public_path__ + "static/media/TalentConnectLogo.a9a9bd07faa552d88c16fe39d5354090.svg";
export { ForwardRef as ReactComponent };